import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ArticlesGrid } from '../components/ArticlesGrid';
import { MediaSection } from '../components/MediaSection';
import { TimelineSection } from '../components/TimelineSection';
import { WorkHistorySection } from '../components/WorkHistorySection';
import { ContactSection } from '../components/ContactSection';
export function HomePage() {
  // Enable smooth scrolling on the document level
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-223">
      <Navigation data-id="element-224" />

      <main data-id="element-225">
        <HeroSection data-id="element-226" />
        <AboutSection data-id="element-227" />
        <ArticlesGrid data-id="element-228" />
        <MediaSection data-id="element-229" />
        <TimelineSection data-id="element-230" />
        <WorkHistorySection data-id="element-231" />
      </main>

      <ContactSection data-id="element-232" />
    </div>;
}